import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '1.5rem',
  },
  textField: {
    width: '16rem',
  },
  deleteButton: {
    marginTop: '1rem',
  },
}));

export default useStyles;
